module.exports = __webpack_public_path__ + "img/02.0cbd596b.jpg";